
import { baseSplitApi } from "../../baseApi";


// const clockInPath = '/attendance/userclockin'

// const clockOutPath = '/attendance/userclockout'

// const addAttendanceDataCollection = '/attendance/userstatus'

// const clockInClockOutDataPath = '/attendance/userintervaldata'

// const attendanceTableTag = 'ATTENDANCETABLE'
 const collegeListPath='/recruitment/college'
const addRecruitmentDataPath="/recruitment/onboard"
const verifyEmailCollegePath='/recruitment/verify/email/send_otp/'
const verifyOtpPath='/recruitment/verify/email/verify_otp'


export const verificationApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        // clockIn: build.mutation({
        //     query: (clockInData) => {
        //         return {
        //             url: clockInPath,
        //             method: 'PUT',
        //             body: clockInData
        //         }
        //     },
        //     invalidatesTags: [attendanceTableTag]
        // }),
        verifyEmailCollege: build.mutation({
            query: (details) => {
                return {
                    url: verifyEmailCollegePath,
                    method: 'POST',
                    body: details
                }
            },
           
        }),
        verifyOTP: build.mutation({
            query: (verification) => {
                return {
                    url: verifyOtpPath,
                    method: 'POST',
                    body: verification
                }
            },
           
        }),
        // getCollegeList: build.query({
        //     query: () => {
        //         return {
        //             url:collegeListPath ,
        //             method: 'GET'
        //         }
        //     },
           
        // }),
        addRecruitmentData: build.mutation({
            query: (recruitmentData) => {
                return {
                    url: addRecruitmentDataPath,
                    method: 'POST',
                    body: recruitmentData
                }
            },
           
        }),
        // getAllClockInClockoutData: build.query({
        //     query: ({ startDate, endDate }) => {
        //         return {
        //             url: `${clockInClockOutDataPath}?startDate=${startDate}&endDate=${endDate}`,
        //             method: 'GET',
        //         }
        //     },
        //     providesTags: [attendanceTableTag, updateRegularizationStatusTag, newLoginTag]
        // })
    }),
    overrideExisting: false,
})

export const { useVerifyEmailCollegeMutation,useVerifyOTPMutation,useAddRecruitmentDataMutation } = verificationApi